/**
 * 根据当前窗口的宽度动态更新样式，以适应移动端或桌面端的需求。
 * 该函数会根据窗口宽度判断设备类型（移动端或桌面端），
 * 然后调整视频弹窗的宽度和关闭按钮的大小。
 * 
 * 在移动端（窗口宽度小于或等于768px）时，执行以下操作：
 * - 弹窗宽度设置为 100%（全宽）
 * - 关闭按钮的大小设置为 30px x 30px
 * 
 * 在桌面端（窗口宽度大于768px）时，执行以下操作：
 * - 弹窗宽度设置为 80%
 * - 关闭按钮的大小设置为 60px x 60px
 *  
 *  使用方式：给需要点击播放的元素设置 dialogPlayVideo class 和 dialog-src属性
 * 
 *  eg: <div class="dialogPlayVideo" dialog-src="xxx"></div>
 *
 * */


document.addEventListener('DOMContentLoaded', function () {
  // 创建弹窗和遮罩元素
  function createOverlay() {
    const overlay = document.createElement('div');
    overlay.id = "videoPlayOverlay";
    Object.assign(overlay.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 10086,
      display: 'none'
    });
    document.body.appendChild(overlay);
  }

  // 创建关闭按钮
  function createCloseButton() {
    const closeButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    closeButton.id = "videoPlayOverlayCloseButton";
    closeButton.setAttribute('width', '24');
    closeButton.setAttribute('height', '24');
    closeButton.setAttribute('viewBox', '0 0 24 24');
    closeButton.setAttribute('fill', 'none');
    closeButton.setAttribute('stroke', 'currentColor');
    closeButton.setAttribute('stroke-width', '2');
    closeButton.setAttribute('stroke-linecap', 'round');
    closeButton.setAttribute('stroke-linejoin', 'round');
    closeButton.innerHTML = `
        <circle cx="12" cy="12" r="10"></circle>
        <path d="m15 9-6 6"></path>
        <path d="m9 9 6 6"></path>
    `;
    closeButton.style.position = 'fixed';
    closeButton.style.top = '50px';
    closeButton.style.right = '50px';
    closeButton.style.cursor = 'pointer';
    closeButton.style.zIndex = 10087;
    closeButton.style.color = '#fff';
    closeButton.style.width = '60px';
    closeButton.style.height = '60px';
    closeButton.style.display = 'none';
    document.body.appendChild(closeButton);
  }


  function createModalVideo() {
    const modalVideo = document.createElement('video');
    modalVideo.id = "videoPlayOverlayVideo";
    modalVideo.setAttribute('controls', true);
    Object.assign(modalVideo.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 10087,
      width: '80%',
      height: 'auto',
      objectFit: 'cover',
      maxHeight: '80%',
      backgroundColor: '#000',
      textAlign: 'center',
      overflow: 'hidden',
      display: 'none'
    });
    document.body.appendChild(modalVideo);
  }

  // 判断是否为移动端
  const updateStylesForDevice = () => {
    const isMobile = window.innerWidth <= 768;
    const modalVideo = document.getElementById('videoPlayOverlayVideo');
    const closeButton = document.getElementById('videoPlayOverlayCloseButton');
    if (isMobile) {
      Object.assign(modalVideo.style, { width: '100%' });
      Object.assign(closeButton.style, { width: '30px', height: '30px', top: '20px', right: '20px' });
    } else {
      Object.assign(modalVideo.style, { width: '80%' });
      Object.assign(closeButton.style, { width: '60px', height: '60px', top: '50px', right: '50px' });
    }
  };

  // 关闭弹窗的事件
  function closeModal() {
    const overlay = document.getElementById('videoPlayOverlay');
    const modalVideo = document.getElementById('videoPlayOverlayVideo');
    const closeButton = document.getElementById('videoPlayOverlayCloseButton');

    overlay.style.display = 'none';
    modalVideo.pause();
    modalVideo.src = ''; // 停止视频并清空src
    modalVideo.style.display = 'none';
    closeButton.style.display = 'none';
  }

  // 按下Esc键关闭弹窗
  const handleEscKey = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  // 添加键盘按键监听
  document.addEventListener('keydown', handleEscKey);

  // 监听窗口大小变化
  window.addEventListener('resize', updateStylesForDevice);

  createOverlay();
  createCloseButton();
  createModalVideo();
  updateStylesForDevice();

  const overlay = document.getElementById('videoPlayOverlay');
  const closeButton = document.getElementById('videoPlayOverlayCloseButton');
  closeButton.addEventListener('click', closeModal);

  // 事件委托处理点击视频播放的事件
  document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('dialogPlayVideo')) {

      const videoSrc = e.target.getAttribute('dialog-src');

      overlay.style.display = 'block';
      overlay.addEventListener('click', closeModal);

      const modalVideo = document.getElementById('videoPlayOverlayVideo');
      modalVideo.src = videoSrc;
      modalVideo.style.display = 'block';
      modalVideo.play();

      closeButton.style.display = 'block';
    }
  });
});